<template>
    <label>
        <Select v-model="currValue" ref="select" clearable :placeholder="placeholder" @on-change="selectChange" :style="styles">
            <Option v-for="item in list" :value="item.id" :key="item.id">{{ item.departmentName }}</Option>
        </Select>
    </label>
</template>

<script>
    import iUser from "@/module/base/api/iUser";

    export default {
        name: "depart-sel",
        props: {
            value: {
                type: Number,
                default: 0
            },
            placeholder: {
                type: String,
                default: '请选择组织'
            },
            departmentType: {
                type: Number,
                default: 0
            },
            width:{
                type:String,
                default:'auto'
            }
        },
        data() {
            return {
                currValue: this.value,
                list: [],
            }
        },
        mounted() {
            this.dataInit();
        },
        methods: {
            dataInit() {
                iUser.departList(this.departmentType).then(res => {
                    this.list = res
                });
            },
            selectChange(val) {
                val = val === undefined ? null : val;
                this.currValue = val;
                if (val !== this.value) {
                    this.$emit('input', val);
                    this.$emit('on-change', val);
                }
            }
        },
        watch: {
            value(val) {
                val = val === undefined ? null : val;
                if (val !== this.currValue) {
                    this.currValue = val;
                }
            }
        },
        computed: {
            styles(){
                return 'width:'+this.width
            }
        }
    }
</script>
